import { render, staticRenderFns } from "./BeautyCategory.vue?vue&type=template&id=536e24f9&scoped=true"
import script from "./BeautyCategory.vue?vue&type=script&lang=js"
export * from "./BeautyCategory.vue?vue&type=script&lang=js"
import style0 from "./BeautyCategory.vue?vue&type=style&index=0&id=536e24f9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536e24f9",
  null
  
)

export default component.exports